<!--
  <mat-toolbar color="warn" class="toolbar justify-content-center" *ngIf="isTest">{{ 'Foundation.TestEnvironmentNotice' | translate }}</mat-toolbar>
-->
<router-outlet></router-outlet>
